/**
 * JaaS customer statuses which represent their account state.
 */
export const STATUSES = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED'
};

/**
 * URL for displaying JaaS upgrade options.
 */
export const JAAS_UPGRADE_URL = 'https://jaas.8x8.vc/#/plan/upgrade';

/**
 * The prefix for the vpaas tenant.
 */
export const VPAAS_TENANT_PREFIX = 'vpaas-magic-cookie-';
